
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/products",
      function () {
        return require("private-next-pages/marketplace/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/products"])
      });
    }
  